import { render, staticRenderFns } from "./message-log.vue?vue&type=template&id=3ff00bd2&scoped=true"
import script from "./message-log.vue?vue&type=script&lang=js"
export * from "./message-log.vue?vue&type=script&lang=js"
import style0 from "./message-log.vue?vue&type=style&index=0&id=3ff00bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff00bd2",
  null
  
)

export default component.exports